<template>
    <button type="button" class="landing-cta" :class="[ type, { 'has-arrow': hasArrow, 'no-arrow': noArrow, 'hover-arrow-on-no-arrow': hasHoverArrowOnNoArrow } ]">
        <span v-if="label" :data-label="label">{{ label }}</span>
        <ButtonArrowIcon v-if="hasArrow" :size="arrowSize" :variant="type" />
        <ArrowIcon v-else-if="hasInlineArrow" :size="24" class="inline-arrow" />
        <slot v-else></slot>
    </button>
</template>

<script>
    import ArrowIcon from "../icons/ArrowIcon.vue";
    import ButtonArrowIcon from "../icons/ButtonArrowIcon.vue";

    export default {
        name: 'CtaButton',
        props: {
            label: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: "primary" // primary, secondary, tertiary, inline
            },
            noArrow: {
                type: Boolean,
                default: false
            },
            hoverArrowOnNoArrow: {
                type: Boolean,
                default: false
            },
            inlineArrow: {
                type: Boolean,
                default: false
            }
        },
        components: {
            ArrowIcon,
            ButtonArrowIcon
        },
        computed: {
            hasHoverArrowOnNoArrow() {
                return this.hoverArrowOnNoArrow || (this.type === "tertiary" && this.noArrow);
            },
            hasArrow() {
                return this.type !== "inline" && !this.$slots.default && (!this.noArrow || this.hasHoverArrowOnNoArrow);
            },
            hasInlineArrow() {
                return this.type === "inline" && this.inlineArrow;
            },
            arrowSize() {
                return this.type === "tertiary" ? 12 : 13;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../styles/public-pages/components/buttons";
</style>

<style lang="scss" global>
.landing-cta {
    &.primary {
        &:hover {
            svg {
                path {
                    fill: var(--color-btn-primary-text-hover);
                }
            }
        }
    }
    &.secondary {
        &:hover {
            svg {
                path {
                    fill: var(--color-btn-secondary-text);
                }
            }
        }
    }
    &.tertiary {
        &:hover {
            svg {
                path {
                    fill: var(--color-btn-tertiary-text);
                }
            }
        }
    }
    &.inline {
        svg {
            path {
                fill: var(--color-btn-inline-text);
            }
        }
        &:hover {
            svg {
                path {
                    fill: var(--color-btn-inline-text-hover);
                }
            }
        }
    }
}
</style>
